import type { SvgIconComponent } from '@mui/icons-material';
import DeliveryDiningRounded from '@mui/icons-material/DeliveryDiningRounded';
import EmailRounded from '@mui/icons-material/EmailRounded';
import { api, unwrap, type Schemas } from '../../api/client';

/** Paid add-ons beside WhatsApp (which keeps its own endpoints and screens). */
export type PluginName = 'foodpanda' | 'email';
export type PlatformPlugin = Schemas['PlatformPlugin'];
export type PluginPeriod = Schemas['PluginPeriod'];
export type PluginRevenue = Schemas['PluginRevenue'];

export const PLUGINS: Record<
  PluginName,
  { label: string; icon: SvgIconComponent; color: string; hidden: string }
> = {
  foodpanda: {
    label: 'Foodpanda',
    icon: DeliveryDiningRounded,
    color: '#D70F64',
    hidden: 'Foodpanda orders are refused and the Foodpanda screens are hidden again',
  },
  email: {
    label: 'Email',
    icon: EmailRounded,
    color: '#05473E',
    hidden: 'Sending by email is hidden again',
  },
};

export const pluginKeys = {
  tenant: (plugin: PluginName, id: string) =>
    ['platform', 'plugins', plugin, 'tenant', id] as const,
  revenue: (plugin: PluginName) => ['platform', 'plugins', plugin, 'revenue'] as const,
};

export function fetchTenantPlugin(plugin: PluginName, id: string) {
  return unwrap(
    api.GET('/platform/tenants/{id}/plugins/{plugin}', { params: { path: { id, plugin } } }),
  );
}

export function fetchPluginRevenue(plugin: PluginName) {
  return unwrap(api.GET('/platform/plugins/revenue', { params: { query: { plugin } } }));
}

export const PERIOD_LABELS: Record<PluginPeriod['kind'], string> = {
  ENABLED: 'Enabled',
  EXTENDED: 'Extended',
  GRACE_CHANGED: 'Grace changed',
  DISABLED: 'Turned off',
};
